import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image — luxury development/residential project */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e0b0a6d0354dc0194030c142a02ec4eb.jpg"
          alt="Studio 1323 — Architectural Design for Residential, Development and Hospitality Projects in Santa Monica"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-8 lg:px-14 pt-28 pb-20">
        <div className="max-w-3xl">
          <p className="text-white/60 text-xs tracking-[0.3em] uppercase font-medium mb-7">
            Studio 1323 &nbsp;·&nbsp; Architecture &amp; Design &nbsp;·&nbsp; Santa Monica, CA
          </p>

          <h1 className="font-serif text-5xl lg:text-[68px] xl:text-[82px] text-white leading-[1.03] font-light mb-6">
            Architectural Design<br />
            <em className="not-italic text-white/80 font-light">for Residential,</em><br />
            <strong className="font-semibold text-white">Development &amp; Hospitality</strong>
          </h1>

          <p className="text-white/70 text-lg font-light leading-relaxed max-w-xl mb-4">
            A Santa Monica architecture firm delivering precision-crafted projects across Los Angeles — custom homes, multi-family developments, boutique hotels, and renovations.
          </p>

          {/* Trust signals */}
          <div className="flex items-center gap-6 mb-10">
            {[
              { num: "15+", label: "Years" },
              { num: "60+", label: "Projects" },
              { num: "4", label: "Sectors" },
            ].map((s) => (
              <div key={s.label} className="flex items-center gap-2">
                <span className="text-white font-semibold text-lg">{s.num}</span>
                <span className="text-white/50 text-xs uppercase tracking-wider">{s.label}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap items-center gap-4">
            <Link
              to="/contact"
              className="px-9 py-4 bg-white text-arch-charcoal text-xs tracking-[0.18em] uppercase font-semibold hover:bg-white/90 transition-all rounded-md cursor-pointer whitespace-nowrap"
            >
              Request Consultation
            </Link>
            <Link
              to="/projects"
              className="px-9 py-4 border border-white/50 text-white text-xs tracking-[0.18em] uppercase font-medium hover:bg-white/10 hover:border-white transition-all rounded-md cursor-pointer whitespace-nowrap"
            >
              View Portfolio
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40">
        <div className="w-px h-10 bg-white animate-pulse" />
        <p className="text-white text-xs tracking-[0.25em] uppercase">Scroll</p>
      </div>

      {/* Bottom-right credentials */}
      <div className="absolute bottom-10 right-8 lg:right-14 hidden lg:flex flex-col items-end gap-1">
        <p className="text-white/35 text-xs tracking-[0.2em] uppercase">Licensed Architect</p>
        <p className="text-white/35 text-xs tracking-[0.2em] uppercase">State of California</p>
      </div>
    </section>
  );
}
